<template>
  <div>
    <h2>{{ $t('title.organizations') }}</h2>

    <base-list
    model="organizations"
    :columns="['name', 'owner']"
    sModel="organization"
    />
  </div>

</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'organization-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// OrganizationList.vue?38d1bed2